import { render, staticRenderFns } from "./AppointmentsManager.vue?vue&type=template&id=18e718eb"
import script from "./AppointmentsManager.vue?vue&type=script&lang=js"
export * from "./AppointmentsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports